import React from 'react';
import css from '../Tables.module.css';
import googleAdsMiniLogo from '../../../../assets/googleAdsMiniLogo.svg';
import facebookMiniLogo from '../../../../assets/facebookMiniLogo.svg';

import { formater } from './functions';
import { parceBudget, parcePercentage } from '../../../../helpers/parceBudget';
import { formatNumber } from '../../../../utils/formatNumber';

export const CampaignsPerformance = ({
  type,
  el,
  isTotalRow,
  handleClickBudget,
  handleClickClient,
  handleCheckOne,
}) => {
  return (
    <tr
      className={`${css.tr} ${isTotalRow ? css.trTotal : ''}`}
      key={formater('key', el, type)}
    >
      <td className={css.td} style={{ width: 30 }}>
        {!isTotalRow && (
          <input
            className={css.checkbox}
            type="checkbox"
            checked={el.isChecked}
            onChange={handleCheckOne.bind(this, formater('key', el, type))}
          />
        )}
      </td>

      <td className={css.td}>
        {
          isTotalRow && "Total"
        }
        {el.source === 'G' && (
          <div className={css.flexCenter}>
            <img src={googleAdsMiniLogo} alt="google_logo"/>
          </div>
        )}
        {el.source === 'F' && (
          <div className={css.flexCenter}>
            <img src={facebookMiniLogo} alt="facebook_logo"/>
          </div>
        )}
      </td>

      <td className={css.td} style={{ color: '#1649EC' }}>
        <div className={css.tdImageWrapper}>
          {el.status === 'E' && <div className={css.circle} />}
          {el.status === 'P' && (
            <div className={css.pauseContainer}>
              <div className={css.pauseElem} />
              <div className={css.pauseElem} />
            </div>
          )}
          <span className={css.tdImageSpan}>{el.campaign_name}</span>
        </div>
      </td>

      <td
        className={css.td}
        style={{ color: '#1649EC', cursor: 'pointer' }}
        onClick={handleClickClient}
      >
        {el.client_name}
      </td>

      <td
        className={css.td}
        style={{ color: '#1649EC', cursor: 'pointer' }}
        onClick={handleClickBudget}
      >
        {el.budget_name}
      </td>
      <td className={css.td}>{formatNumber(el.impressions)}</td>
      <td className={css.td}>{formatNumber(el.clicks)}</td>

      <td className={css.td}>{parceBudget(el.spend, el.currency)}</td>

      <td className={css.td}>{formatNumber((+el.conversions).toFixed(0))}</td>

      <td className={css.td}>{parceBudget(el.cpa, el.currency)}</td>

      <td className={css.td}>{parceBudget(el.revenue, el.currency)}</td>

      <td className={css.td}>{parcePercentage(el.roas)}</td>

      <td
        className={`${css.td} ${formater(
          'cpa/roas_change',
          el.seven_days_cpa_change,
        )}`}
      >
        {parcePercentage(el.seven_days_cpa_change)}
      </td>

      <td
        className={`${css.td} ${formater(
          'roas_change',
          el.seven_days_roas_change,
        )}`}
      >
        {parcePercentage(el.seven_days_roas_change)}
      </td>
      <td className={css.td}>{+el.all_conversions}</td>
    </tr>
  );
};
